import { useState } from "react";
import { u as uuid } from "../uuid.js";
const useUuid = (initial) => {
  const [id] = useState(initial || uuid());
  return id;
};
export {
  useUuid
};
//# sourceMappingURL=useUuid.js.map
